// src/firebase-messaging.ts
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { app } from "./firebase";
// Initialize messaging
const messaging = getMessaging(app);

/**
 * Requests the user's permission to show notifications and retrieves the FCM token.
 * Replace 'YOUR_PUBLIC_VAPID_KEY' with your key from the Firebase console under Cloud Messaging.
 */
export const requestForToken = async (): Promise<string | null> => {
    try {
        if (Notification.permission !== 'granted') {
            const permission = await Notification.requestPermission();
            if (permission !== 'granted') return null;
        }
        const registration = await navigator.serviceWorker.ready;
        const currentToken = await getToken(messaging, {
            vapidKey: "BBjXU--cIT6HZEsHEB2yUSjH5v6HgNs3jlnJbZuU1-uaGokMSZD6GhwGArNwrOMhhBNfsuxg9xSTD2xiA6_vSFM",
            serviceWorkerRegistration: registration
        });
        if (currentToken) {

            return currentToken;
        } else {
            console.log("No registration token available. Request permission to generate one.");
            return null;
        }
    } catch (error) {
        console.error("An error occurred while retrieving token. ", error);
        return null;
    }
};

/**
 * Listens for foreground messages.
 * Returns a promise that resolves when a new message is received.
 */
export const onMessageListener = (): Promise<any> =>
    new Promise((resolve) => {
        onMessage(messaging, (payload: any) => {
            if (Notification.permission === 'granted') {
                new Notification(payload.notification.title, {
                    body: payload.notification.body,
                    icon: payload.notification.icon
                });
            }
            resolve(payload);
        });
    });
